// src/pages/DashboardHome.jsx
import React from 'react';
import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import CarouselSection from '../components/dashboard/CarouselSection';
import CategorySection from '../components/dashboard/CategorySection';
import PlaylistCard from '../components/custom-ui/PlaylistCard';
import SongCard     from '../components/custom-ui/SongCard';
import MediaStripList from '../components/custom-ui/MediaStripList';
import VerticalStripCarousel from '../components/custom-ui/VerticalStripCarousel';
import PersonalizeBanner from '../components/dashboard/Personalized Service/PersonalizeBanner';
import { useSubscription } from '../context/SubscriptionContext';
import PersonalizeCTA from '../components/dashboard/Personalized Service/PersonalizeCTA';
import PBMyRecommendations from '../components/dashboard/Personalized Service/PBMyRecommendations';

import {
  useGetDashboardAllPlaylistsQuery,
  useGetDashboardFreePlaylistsQuery,
  useGetDashboardNewReleasesQuery,
  useGetRecentPlaysQuery,
  useGetRecentPlaylistsQuery
} from '../utils/api';

const DashboardHome = () => {

  const navigate = useNavigate()
  const location = useLocation()
  const { isRecommendationOnly } = useSubscription();

  useEffect(() => {
    const returnTo = sessionStorage.getItem('returnToPath') || sessionStorage.getItem('returnTo');
    if (returnTo) {
      sessionStorage.removeItem('returnToPath')
      sessionStorage.removeItem('returnTo')
      navigate(returnTo, { replace: true })
    }
  }, [navigate])



  const { data: nrRaw = {}, isLoading: nrL, isError: nrE } =
    useGetDashboardNewReleasesQuery({ playlistLimit: 12, songLimit: 8 });
  const newPlaylists = Array.isArray(nrRaw.playlists) ? nrRaw.playlists : [];
  const newSongs     = Array.isArray(nrRaw.songs)     ? nrRaw.songs     : [];
  const combinedNew  = [
    ...newPlaylists.map(pl => ({ type: 'playlist', data: pl })),
    ...newSongs.map(s   => ({ type: 'song',     data: s  })),
  ];


 const { data: rpRaw, isLoading: rpL, isError: rpE } = useGetRecentPlaysQuery(10);
   
 const recentItemsRaw = Array.isArray(rpRaw) ? rpRaw : (rpRaw?.items ?? []);
   
 const recentItems = recentItemsRaw.map(s => ({
   ...s,
   slug: s?.slug ?? s?.song_slug ?? s?.id?.toString(),
 }));

 const { data: rplRaw, isLoading: rplL, isError: rplE } = useGetRecentPlaylistsQuery(8);
  const recentPlaylists = Array.isArray(rplRaw) ? rplRaw : (rplRaw?.items ?? []);
  
  const normalizedRecentPlaylists = recentPlaylists.map(p => ({
    ...p,
    slug: p?.slug ?? p?.playlist_slug ?? p?.id?.toString(),
  }));


  return (
      <div className="space-y-1 sm:space-y-6 rounded-2xl">
      <CategorySection />

      {/* <PersonalizeBanner /> */}

      {/* {!isRecommendationOnly && (
      <CarouselSection
        title="New Releases"
        items={combinedNew}
        renderItem={({ type, data }) =>
          type === 'playlist'
            ? <PlaylistCard key={`pl-${data.id}`} playlist={data} />
            : <SongCard     key={`s-${data.id}`}  song={data}      />
        }
      />
      )} */}

      {!isRecommendationOnly && (
        <>
          {/* 📱 Mobile Vertical Carousel */}
          <div className="lg:hidden">
            <VerticalStripCarousel
              title="New Releases"
              items={combinedNew}
            />
          </div>

          {/* 🖥 Desktop Existing Horizontal Carousel */}
          <div className="hidden lg:block">
            <CarouselSection
              title="New Releases"
              items={combinedNew}
              renderItem={({ type, data }) =>
                type === 'playlist'
                  ? <PlaylistCard key={`pl-${data.id}`} playlist={data} />
                  : <SongCard     key={`s-${data.id}`}  song={data}      />
              }
            />
          </div>
        </>
      )}


      <PBMyRecommendations />



      {/* Recently Played */}
      {/* {!isRecommendationOnly && !rpL && !rpE && recentItems.length > 0 && (
        <CarouselSection
          title="Recently Played Songs"
          items={recentItems}
          renderItem={(song) => (
            <SongCard
              key={`s-${song.id}-${song.slug}`}
              song={song}
              onPlay={() => {}}
            />
          )}
        />
      )} */}

      {!isRecommendationOnly && !rplL && !rplE && normalizedRecentPlaylists.length > 0 && (
        <CarouselSection
          title="Recently Played"
          items={normalizedRecentPlaylists}
          renderItem={(pl) => (
            <PlaylistCard key={`rpl-${pl.id}`} playlist={pl} />
          )}
        />
      )}


      {/* Free Playlists */}
      <CarouselSection
        title="Free Playlists"
        useQuery={useGetDashboardFreePlaylistsQuery}
        renderItem={(pl) => <PlaylistCard key={pl.id} playlist={pl} />}
      />

      {/* All Playlists */}
      {!isRecommendationOnly && (
      <CarouselSection
        title="All Playlists"
        useQuery={useGetDashboardAllPlaylistsQuery}
        renderItem={(pl) => <PlaylistCard key={pl.id} playlist={pl} />}
      />
      )}

      <PersonalizeCTA/>
      
    </div>
    
  );
};

export default DashboardHome;
